import { StatusAvailability } from '../../enum/StatusAvailability';

export const getStatusAvailabilityOptions = (onlyText?: string) => [
  { title: 'Include', value: StatusAvailability.Include },
  { title: 'Exclude', value: StatusAvailability.Exclude },
  { title: `${onlyText ? onlyText + ' ' : ''}Only`, value: StatusAvailability.Only },
];
